import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {IPartialCollaboratorPayload} from '../Collaborator.ts';
import {CollaboratorApi} from '../../../apis/CollaboratorApi/CollaboratorApi.ts';

export function usePostPartialCollaborator() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, IPartialCollaboratorPayload>({
        mutationKey: [QueryKeys.collaborator],
        mutationFn: async (variables: IPartialCollaboratorPayload) => {
            const id = await CollaboratorApi.postPartialCollaborators(variables);
            return id;
        },
        onSuccess: (id) => {
            queryClient.setQueryData<number>([QueryKeys.collaborator], () => {
                return id;
            });
        },
        onError: (error) => {
            return error.message;
        },
    });
}